export const ShareTargetType = {
	all: 'all',
	friends: 'friends',
	publisher: 'publisher',
	colleagues: 'colleagues',
	generalCommunity: 'generalCommunity',
	nomination: 'nomination',
	genreCommunity: 'genreCommunity',
};
